module.exports = __webpack_public_path__ + "static/media/boa-hancock-lose.869ff2a8.png";